export function getRandomNumber() {
  return Math.trunc(Math.random() * 100000000);
}

export function toCapitalCase(str: string) {
  const word = str.toLowerCase();
  const words = word.split(" ");

  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );

  const capitalizedString = capitalizedWords.join(" ");

  return capitalizedString;
}

export function calculatePriceDiff(price: string, comparePrice: string) {
  const newPrice = price.replace("$", "");
  const newComparePrice = comparePrice.replace("$", "");

  return parseInt(newComparePrice) - parseInt(newPrice);
}

export const dateFormatter = (date: string) => {

  const inputDate = new Date(date).toISOString().split('T')[0];

  return inputDate;

}
